'use client';
import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, RefreshCw } from 'lucide-react';

// Backend integration: GET /api/integrations/sync-log?limit=20
const syncLog = [
  { id: 'log-001', time: '13:54:02', integration: 'ServiceJockey', event: 'Job sync', records: 3, status: 'success', duration: '0.4s' },
  { id: 'log-002', time: '13:51:18', integration: 'Samsara GPS', event: 'Position update batch', records: 24, status: 'success', duration: '0.1s' },
  { id: 'log-003', time: '13:49:55', integration: 'RigJockey', event: 'Asset status pull', records: 8, status: 'warning', duration: '2.1s', detail: 'Response time exceeded 2s threshold' },
  { id: 'log-004', time: '13:44:30', integration: 'ServiceJockey', event: 'Customer record sync', records: 12, status: 'success', duration: '0.6s' },
  { id: 'log-005', time: '13:38:11', integration: 'RigJockey', event: 'Rig schedule pull', records: 2, status: 'success', duration: '0.9s' },
  { id: 'log-006', time: '13:32:44', integration: 'Samsara GPS', event: 'Geofence event', records: 1, status: 'success', duration: '0.1s' },
  { id: 'log-007', time: '13:28:19', integration: 'ServiceJockey', event: 'Job status push', records: 5, status: 'success', duration: '0.5s' },
  { id: 'log-008', time: '13:21:03', integration: 'RigJockey', event: 'Asset sync', records: 0, status: 'error', duration: '5.0s', detail: 'Connection timeout after 5s — endpoint unreachable' },
  { id: 'log-009', time: '13:15:47', integration: 'Samsara GPS', event: 'Position update batch', records: 22, status: 'success', duration: '0.2s' },
  { id: 'log-010', time: '13:09:30', integration: 'ServiceJockey', event: 'Invoice sync', records: 4, status: 'success', duration: '0.8s' },
];

const statusConfig = {
  success: { icon: CheckCircle, color: 'text-emerald-400' },
  warning: { icon: AlertTriangle, color: 'text-amber-400' },
  error: { icon: XCircle, color: 'text-red-400' },
};

export default function SyncLogPanel() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-sm font-semibold text-zinc-200">Sync Log</h2>
          <p className="text-xs text-zinc-500 mt-0.5">Recent integration events and data sync history</p>
        </div>
        <button className="flex items-center gap-1.5 text-xs px-3 py-1.5 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 rounded-lg text-zinc-400 transition-all">
          <RefreshCw size={11} /> Refresh
        </button>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-zinc-800">
              {['Time', 'Integration', 'Event', 'Records', 'Duration', 'Status', 'Detail'].map((h) => (
                <th key={`log-h-${h}`} className="text-left px-4 py-3 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800/50">
            {syncLog.map((entry) => {
              const sc = statusConfig[entry.status as keyof typeof statusConfig];
              const StatusIcon = sc.icon;
              return (
                <tr key={entry.id} className={`hover:bg-zinc-800/40 transition-colors ${entry.status === 'error' ? 'bg-red-950/10' : ''}`}>
                  <td className="px-4 py-2.5 text-xs font-mono text-zinc-500">{entry.time}</td>
                  <td className="px-4 py-2.5 text-xs font-semibold text-zinc-300">{entry.integration}</td>
                  <td className="px-4 py-2.5 text-xs text-zinc-400">{entry.event}</td>
                  <td className="px-4 py-2.5 text-xs font-mono text-zinc-400 tabular-nums">{entry.records}</td>
                  <td className="px-4 py-2.5 text-xs font-mono text-zinc-500">{entry.duration}</td>
                  <td className="px-4 py-2.5">
                    <span className={`flex items-center gap-1 text-[11px] font-medium ${sc.color}`}>
                      <StatusIcon size={11} /> {entry.status}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 text-[11px] text-zinc-600 max-w-[200px] truncate">{entry.detail ?? '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}